import { SaveFeedbackContextValue } from '@modules/feedback/components/FeedbackCard/SaveFeedbackContext';

export const getFeedbackIDForEQL = (
  feedbackID: string,
  savedFeedbackContext: SaveFeedbackContextValue | null,
) => {
  if (!savedFeedbackContext?.snippetID) {
    return feedbackID;
  }

  const { labelID, summaryIndex, summaryHash } = savedFeedbackContext;

  return `${feedbackID}[labelID=${labelID}][summaryHash=${summaryHash}][summaryIdx=${summaryIndex}]`;
};
